import "./styles.scoped.css";
export default {
    "option": "awsui_option_1p2cx_1tubf_97",
    "disabled": "awsui_disabled_1p2cx_1tubf_113",
    "parent": "awsui_parent_1p2cx_1tubf_116",
    "content": "awsui_content_1p2cx_1tubf_123",
    "label-content": "awsui_label-content_1p2cx_1tubf_130",
    "label": "awsui_label_1p2cx_1tubf_130",
    "tag": "awsui_tag_1p2cx_1tubf_137",
    "label-tag": "awsui_label-tag_1p2cx_1tubf_138",
    "label-prefix": "awsui_label-prefix_1p2cx_1tubf_149",
    "tags": "awsui_tags_1p2cx_1tubf_162",
    "description": "awsui_description_1p2cx_1tubf_163",
    "icon": "awsui_icon_1p2cx_1tubf_180",
    "icon-size-big": "awsui_icon-size-big_1p2cx_1tubf_187",
    "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_1tubf_191",
    "trigger-variant": "awsui_trigger-variant_1p2cx_1tubf_206"
};
